/*
  This palette object should not be used outside the Ribbons package.
  The correct way for Ribbons consumers to use these colors is via the
  CSS variables that are included in the base styles.
 */
export const palette = {
  primary: {
    purpleBaseHighContrast: '#5f55d4',
    purpleBase: '#7066E0',
    purple70: '#9B94E9',
    purple50: '#B8B3F0',
    purple30: '#D4D1F5',
    purple10: '#F1F0FC',
    purple5: '#F8F8FF',
  },
  secondary: {
    blupleBase: '#280664',
    bluple70: '#5D5187',
    bluple50: '#9483B2',
    bluple30: '#BEB4D0',
    bluple10: '#EAE6F0',
  },
  tertiary: {
    pinkBase: '#F287D5',
    pink50: '#F9C3EA',
    pink30: '#FBDBF2',
    pink10: '#FEF3FB',

    blueBase: '#87D6F2',
    blue50: '#C3EBF9',
    blue30: '#DBF2FB',
    blue10: '#F3FBFE',

    coralBase: '#F29387',
    coral50: '#F9C9C3',
    coral30: '#FBDEDB',
    coral10: '#FEF4F3',

    greenBase: '#87F290',
    green50: '#C3F8C7',
    green30: '#DBFBDD',
    green10: '#F3FDF3',

    yellowBase: '#FFE583',
    yellow50: '#FFF2C1',
    yellow30: '#FFF7D9',
    yellow10: '#FFFDF3',

    redBase: '#F2879D',
    red50: '#F9C3CE',
    red30: '#FBDBE1',
    red10: '#FEF3F6',
  },
  functional: {
    greenDeep: '#0E5E00',
    greenBase: '#138900',
    green50: '#89C480',
    green30: '#B8DCB3',
    green10: '#E7F3E6',

    yellowBase: '#ECC800',
    yellow50: '#F5E380',
    yellow30: '#F9EEB3',
    yellow10: '#FDF9E6',

    redBase: '#D9253B',
    red50: '#EC929D',
    red30: '#F4BEC4',
    red10: '#FBE9EB',
  },
  neutral: {
    blackBase: '#1E1E29',
    black70: '#58585F',
    black40: '#AAAAAE',
    black30: '#BBBBBE',
    black10: '#E9E9EA',

    white: '#FFFFFF',
  },
} as const;
